import { IFirstHandReport } from '@/api/home/types';
import { IResortPathInfo } from '@/api/resort/types';
import { ItemsContainer } from '@/components/common/ItemsContainer';
import { FirstHandReportItem } from './FirstHandReportItem';

interface Props {
  title: string;
  slides: JSX.Element[];
  reports: IFirstHandReport[];
  regionResorts: Array<IResortPathInfo>;
  controlsHiddenOnMobile?: boolean;
}

// Carousel of first-hand reports on the home page. One row, swipe on
// mobile, chevron-nav scroll-snap rail at desktop. Title + nav chrome
// is owned by common/ItemsContainer; this component is just the data wiring
// over the FHR card.

export const NewGuideSlider = ({
  title, reports, regionResorts,
}: Props) => {
  const resortPathInfoByUuid = new Map<number, IResortPathInfo>(
    (regionResorts ?? []).map((resort) => [Number(resort.uuid), resort]),
  );

  const filteredReports = reports.filter((item) => item.largeImage !== null);

  if (filteredReports.length === 0) return null;

  return (
    <section className="mt-10 md:max-lg:px-4">
      <ItemsContainer title={title} ariaLabel={title}>
        {filteredReports.map((item) => (
          <ItemsContainer.Item key={item.uuid}>
            <FirstHandReportItem
              {...item}
              resortPathInfo={resortPathInfoByUuid.get(item.resortUuid)}
            />
          </ItemsContainer.Item>
        ))}
      </ItemsContainer>
    </section>
  );
};
